<template>
  <el-col :span="24" id="pos" v-loading.body="changingPage && !navigating" element-loading-text="Fetching page...">
    <el-row type="flex" justify="start" align="middle" id="pos-header">
      <HeaderInfoText :colspan="9" title="PURCHASE ORDERS" :meta="meta" :selection="selection" />
      <el-col :span="6">
        <el-row type="flex" justify="center" v-if="meta.count > 20">
          <el-pagination
            layout="prev, pager, next, jumper"
            :total="meta.count"
            :page-size="20"
            @current-change="changePage"
            :current-page="currentPage"
          />
        </el-row>
      </el-col>
      <el-col :span="9" class="h-padded right-aligned-col">
        <div style="display:inline-block;">
          <el-select
            v-if="meta.count"
            :disabled="!(selection && selection.length)"
            placeholder="With selected..."
            v-model="actionFilterSelection"
            style="padding: 0 6px;"
            @change="handleActionFilterSelection">
            <el-option
              v-for="(option, i) in actionFilters"
              :key=i
              :label="option.text"
              :value=i
              :disabled="option.disabled">
            </el-option>
          </el-select>
          <el-button plain @click="toggleFilters" style="margin-left: 0;">
            {{ showFilters ? "Hide filters" : "Show filters" }}
          </el-button>
          <router-link :to="{name: 'NewPo'}">
            <el-button :disabled="!hasCreatePermission" type="primary" icon="plus" />
          </router-link>
        </div>
      </el-col>
    </el-row>
    <el-row type="flex" justify="center" align="middle" style="padding: 0 12px;">
      <Filters
        ref="filters"
        :filters="filters"
        :filtersVisible="showFilters"
        :filterSize="5"
        :autoApply="false"
        clearAction="clearPoState"
        clearMetadataAction="resetPoMeta"
        searchAction="fetchPosWithQuery"
        transactionType="Po"
        :lineFieldSearch="otherNameFieldEnabled ? { field: 'other_name', transactionType: 'po' } : null"
        @filterCleared="() => $refs.filters.applyFilters()"
        @doneFiltering="getAppliedFilters">
        <template v-for="(f, i) in filters" :slot="`${f.type}${i}`" slot-scope="props">
          <component :key="i" :is="f.type" :properties="f.props" :ref="`${f.type+'_po_ref'}`" />
        </template>
      </Filters>
    </el-row>
    <el-row type="flex" justify="end" align="middle">
      <el-col>
        <el-row type="flex">
          <TransactionsConfList
            v-if="pos"
            name="po_transactions_conf_list"
            ref="transactions_conf_list"
            :aggridColumns="aggridColumns"
            :rows="pos"
            :emitSelect="true"
            :baseQuery="baseQuery"
            :currentPage="currentPage"
            @onSelect="handleSelectionChange"
          />
        </el-row>
        <el-row v-if="!meta.count && !isFilterLoading" align="middle" justify="center" class="nodata-heading">
          No data available
        </el-row>
      </el-col>
    </el-row>
    <el-dialog
      title=""
      :visible.sync="sendEmailVisible"
      size="large"
      :show-close="true"
      :close-on-press-escape="true"
      @close="closeSendEmailModal">
      <el-row type="flex" align="middle" justify="end" style="border-bottom: 1px solid lightgrey;">
        <HeaderInfoText :colspan="12" title="Send Email" />
        <el-col>
          <el-row type="flex" align="middle" justify="end">
            <el-button type="primary" @click="cancelSendEmail" style="margin: 0 15px;">Cancel</el-button>
            <el-button type="primary" @click="sendEmail" style="margin: 0 15px;">Send Email</el-button>
          </el-row>
        </el-col>
      </el-row>
      <nacha-po-conf-list
        v-show="sendEmailVisible && selectedPos && !emailLoading"
        name="nacha_po_conf_list"
        ref="nacha_po_conf_list"
        :allow-edit="true"
        :allow-notify="false"
        :width="width"
        :height="height"
        :row-data="selectedPos"
        @onSelect="handleSelectedConf"
        @updateCCMail="handleUpdateCCMail"
        @updateFileAttachment="handleUpdateFileAttachment"
      />
      <div v-if="emailLoading" style="min-height: 100px;" v-loading="emailLoading" element-loading-text="Loading..." />
      <el-row v-if="!selectedPos && !selectedPos.length" align="middle" justify="center" class="nodata-heading">
        No data available
      </el-row>
    </el-dialog>
    <el-dialog
      title=""
      :visible.sync="sendEmailVisible"
      size="large"
      :show-close="true"
      :close-on-press-escape="true"
      @close="closeSendEmailModal">
      <el-row type="flex" align="middle" justify="end" style="border-bottom: 1px solid lightgrey;">
        <HeaderInfoText :colspan="12" title="Send Email" />
        <el-col>
          <el-row type="flex" align="middle" justify="end">
            <el-button type="primary" @click="cancelSendEmail" style="margin: 0 15px;">Cancel</el-button>
            <el-button type="primary" @click="sendEmail" style="margin: 0 15px;">Send Email</el-button>
          </el-row>
        </el-col>
      </el-row>
      <nacha-po-conf-list
        v-if="sendEmailVisible && selectedPos"
        name="nacha_po_conf_list"
        ref="nacha_po_conf_list"
        :allow-edit="true"
        :allow-notify="false"
        :width="width"
        :height="height"
        :row-data="selectedPos"
        @onSelect="handleSelectedConf"
        @updateCCMail="handleCellUpdate"
      />
      <el-row v-if="!selectedPos && !selectedPos.length" align="middle" justify="center" class="nodata-heading">
        No data available
      </el-row>
    </el-dialog>
  </el-col>
</template>

<script>
  import store from '@/store/store'
  import { mapGetters } from 'vuex'
  import Filters from '@/components/RetainedFilters.vue'
  import KeywordFilter from '@/components/FilterComponents/KeywordFilter'
  // import SelectFilter from '@/components/FilterComponents/SelectFilter'
  // import AutocompleteFilter from '@/components/FilterComponents/AutocompleteFilter'
  import HeaderInfoText from '@/components/HeaderInfoText'
  import { notify } from '@/utils/helpers/Notify'
  import { listViewMixins } from '@/Mixins/TransactionListViews'
  import TransactionsConfList from '@/components/SigmaClientNew/TransactionsConfList.vue'
  import { retainFiltersOnEntry } from '@/Mixins/SigmaClientNew/transactionGridFilters'
  import NachaPoConfList from '@/components/SigmaClientNew/NachaPoConfList.vue'

  export default {
    components: {
      Filters,
      KeywordFilter,
      // SelectFilter,
      // AutocompleteFilter,
      HeaderInfoText,
      TransactionsConfList,
      NachaPoConfList
    },
    mixins: [ listViewMixins ],
    data () {
      return {
        tableHeight: 500,
        showFilters: true,
        statusValues: [],
        selection: [],
        closing: false,
        actionFilterSelection: null,
        sendEmailVisible: false,
        selectedPos: [],
        ccMail: [],
        emailLoading: false,
        aggridColumns: ['rowSelect', 'idColumn', 'numberColumn', 'vendorColumn', 'descriptionColumn', 'currencyColumn', 'originalAmountColumn', 'remainingAmountColumn', 'batchColumn', 'actionsColumn'],
        selectedStatuses: ['DRAFT', 'OPEN', 'AUDITED', 'POSTED', 'CLOSED', 'VOIDED'],
        statusOptions: [
          { label: 'DRAFT', value: 'DRAFT' },
          { label: 'OPEN', value: 'OPEN' },
          { label: 'AUDITED', value: 'AUDITED' },
          { label: 'POSTED', value: 'POSTED' },
          { label: 'CLOSED', value: 'CLOSED' },
          { label: 'VOIDED', value: 'VOIDED' },
          { label: 'DELETED', value: 'DELETED' }
        ]
      }
    },
    methods: {
      getAppliedFilters () {
        this.$store.dispatch('clearSetPoFilterInfo')
        let extendedFilters = {}
        if (this.$refs.filters.getFilters.search) extendedFilters = { search: this.$refs.filters.getFilters.search }
        sessionStorage.setItem('paginationQuery', JSON.stringify({page: this.currentPage, ...this.$refs.filters.getFilters}))
        sessionStorage.setItem(`gridFilterModel:${this.$route.name}`, JSON.stringify({ page: this.currentPage, extendedFilters: extendedFilters }))
        this.$store.dispatch('setPoFilterInfo', { page: this.currentPage, ...this.$refs.filters.getFilters })
        this.$refs['transactions_conf_list'].extendedFilters = extendedFilters
      },
      /**
       * Handles transaction selection
       * @param selection
       */
      async handleSelectionChange (selection) {
        let notThisPage = this.selection.filter(v => v.page !== this.currentPage)
        this.selection = [...notThisPage, ...selection]
        let promises = []
        this.selection.forEach(selection => {
          if (selection.status === 'POSTED' && selection.lines.length) { // Fetching lines to validate close po
            promises.push(this.$store.dispatch('fetchPoLinesWithQuery', { id__in: selection.lines, page_size: selection.lines.length }))
          }
        })
        if (this.actionFilterSelection) {
          this.actionFilterSelection = null
        }
        await Promise.all(promises)
      },
      /**
       * Closes selected POs
       */
      async closeSelected () {
        try {
          this.closing = true
          const promises = this.filteredToClose.map(v => {
            this.$store.dispatch('updatePo', { id: v.id, data: { status: 'CLOSED' } })
              .then(r => {
                if (r && r.data && r.data.id) {
                  this.selection = this.selection.filter(po => po.id !== r.data.id)
                }
              })
          })
          const resp = await Promise.all(promises)
          if (resp && resp.length) {
            this.selection = []
            notify(this, 'success', 'Purchase Orders Closed')
          }
        } catch (e) {
          console.log(e)
          notify(this, 'danger', 'Error closing selected POs')
        } finally {
          this.actionFilterSelection = null
          this.closing = false
        }
      },
      closeSendEmailModal () {
        this.sendEmailVisible = false
        this.ccMail = []
        if (this.actionFilterSelection) {
          this.actionFilterSelection = null
        }
      },
      async emailSelected (e) {
        this.emailLoading = true
        this.sendEmailVisible = true
        this.ccMail = []
        this.selectedPos = this.selection.map(item => {
          let company = this.getCompanyById(item.batch_data.company)
          return {
            attributes: {
              po_id: item.id,
              vendor_id: item.vendor,
              vendor_name: item.vendor_data.name,
              email: item.vendor_data.email,
              amount_decimal: item.amount_decimal,
              number: item.number,
              description: item.description,
              file_attachment: true,
              resources: [{attributes: {company_email: company.email}}],
              company_email: company.email,
              cc_mail: ''
            }
          }
        })
        this.emailLoading = false
      },
      async sendEmail () {
        try {
          this.emailLoading = true
          let posSelected = []
          let selectedPosWithEmail = []
          let selectedPosWithOutEmail = []
          selectedPosWithEmail = this.selectedPos.filter((obj) => { return obj.attributes.email })
          selectedPosWithOutEmail = this.selectedPos.filter((obj) => { return !obj.attributes.email })
          if (this.selectedPos.length) {
            selectedPosWithEmail.forEach((mail) => {
              let item = {
                id: mail.attributes.po_id,
                file_attachment: mail.attributes.file_attachment,
                cc_mail: false
              }
              if (mail.attributes.cc_mail) {
                item.cc_mail = true
              }
              posSelected.push(item)
            })
            if (posSelected.length) {
              const newPayload = Object.assign({}, { purchase_order: posSelected })
              const resp = await this.$store.dispatch('notifyPos', newPayload)
              if (resp && resp.success.vendors.length) {
                notify(this, 'success', 'Email sent to ' + resp.success.vendors.map((vendor) => vendor.name).join(', '), 10)
                this.emailLoading = false
              }
            }
            // notify if vendors do not have emails
            if (selectedPosWithOutEmail.length) {
              notify(this, 'error', 'Unable to send email to ' + selectedPosWithOutEmail.map((po) => po.attributes.vendor_name).join(', '), 100)
              this.emailLoading = false
            }
          } else {
            this.emailLoading = false
            notify(this, 'error', 'Error sent email')
            return false
          }
        } catch (e) {
          console.log(e)
          this.emailLoading = false
          notify(this, 'error', 'Error sent email')
          return e
        }
      },
      cancelSendEmail () {
        this.sendEmailVisible = false
        this.ccMail = []
        if (this.actionFilterSelection) {
          this.actionFilterSelection = null
        }
      },
      handleSelectedConf (selection, index) {
        this.selectedPos[index].attributes.cc_mail = selection
        this.selectedPos[index].attributes.file_attachment = selection
      },
  
      handleUpdateCCMail (param, index) {
        this.selectedPos[index].attributes.cc_mail = param.newValue
      },
      handleUpdateFileAttachment (param, index) {
        this.selectedPos[index].attributes.file_attachment = param.newValue
      },
      /**
       * Handles action filter selections
      */
      async handleActionFilterSelection (selectedOpt = null) {
        try {
          switch (selectedOpt) {
            case 0:
              this.sendEmailVisible = false
              this.closeSelected()
              break
            case 1:
              this.emailSelected()
          }
        } catch (e) {
          console.log(e)
        }
      },
      /**
       * Handles paginating between PO pages
       * @param page  Target page
       */
      async changePage (page) {
        try {
          this.changingPage = true
          const searchText = this.$refs.filters.getFilters.search ? this.$refs.filters.getFilters.search : ''
          await this.loadRows(page, { search: searchText })
          sessionStorage.setItem('paginationQuery', JSON.stringify({page: page, ...this.$refs.filters.getFilters}))
          sessionStorage.setItem(`gridFilterModel:${this.$route.name}`, JSON.stringify({ page: page, extendedFilters: { search: this.$refs.filters.getFilters.search } }))
          this.$refs['transactions_conf_list'].restoreSelection(this.selection)
        } catch (e) {
          console.log(e) // TODO: use a logger
        } finally {
          this.changingPage = false
        }
      },
      async filterRetained () {
        const saved = JSON.parse(sessionStorage.getItem(`gridFilterModel:${this.$route.name}`))
        if (saved && saved.extendedFilters && saved.extendedFilters.search && this.$refs) {
          this.$nextTick(() => {
            this.$refs.keywordFilter_po_ref[0].keyword = saved.extendedFilters.search
          })
        }
      }
    },
    computed: {
      ...mapGetters({
        pos: 'getPos',
        meta: 'getPoMetadata',
        getPoLinesByTransactionId: 'getPoLinesByTransactionId',
        currentPage: 'getCurrentPoPage',
        getBatchById: 'getBatchById',
        getVendorById: 'getVendorById',
        getCurrencyByBatchId: 'getCurrencyByBatchId',
        getCompanyById: 'getCompanyById',
        getcurrentFilters: 'getFilters',
        getPoFilterInfo: 'getPoFilterInfo',
        checkIfUserHasRequiredPermissions: 'checkIfUserHasRequiredPermissions'
      }),
      /**
       * Criteria this view owns, which the grid's column filters are applied on top of
       */
      baseQuery () {
        return { status__in: this.selectedStatuses }
      },
      width () {
        // Reducing by 3 % to handle sigma-frontend navbar
        return '100%'
      },
      height () {
        // Reducing by 3 % to handle sigma-frontend navbar
        return window.innerHeight * 0.63 + 'px'
      },
      filteredToClose () {
        if (!this.selection.length) return []
        let selectionFilters = []
        for (let i = 0; i < this.selection.length; i++) {
          if (['DRAFT', 'OPEN', 'AUDITED'].includes(this.selection[i].status)) {
            selectionFilters.push(this.selection[i])
          } else if (['POSTED'].includes(this.selection[i].status)) {
            let poLines = Object.values(this.getPoLinesByTransactionId(this.selection[i].id))
            if (poLines.some(v => ['OPEN', 'PARTIAL'].includes(v.type))) {
              selectionFilters.push(this.selection[i])
            } else {
              selectionFilters = []
              break
            }
          }
        }
        return selectionFilters
      },
      /**
       * Determines whether the 'other_name' line field is enabled in admin settings
       * @return {boolean}
       */
      otherNameFieldEnabled () {
        let fieldOrderSetting
        try {
          fieldOrderSetting = JSON.parse(this.$store.getters.getUiSettings['LINE_FIELD_ORDER'])
        } catch (e) {
          if (e instanceof Error && e.name === 'SyntaxError') {
            console.log('Error decoding JSON when getting LINE_FIELD_ORDER setting')
          }
        }
        if (!(fieldOrderSetting && fieldOrderSetting.po && fieldOrderSetting.po.other_name)) {
          return false
        }
        return !fieldOrderSetting.po.other_name.hidden
      },
      hasCreatePermission () {
        return this.checkIfUserHasRequiredPermissions(['entry.view_purchaseorder', 'entry.add_purchaseorder'])
      },
      hasPermission () {
        return {
          read: this.hasReadPermission
        }
      },
      hasReadPermission () {
        let readPermission = ['entry.view_purchaseorder']
        return this.checkIfUserHasRequiredPermissions(readPermission)
      },
      actionFilters () {
        return [
          {
            text: 'Close Selected',
            type: 'close',
            disabled: !(this.filteredToClose && this.filteredToClose.length)
          },
          {
            text: 'Email Selected',
            type: 'email',
            disabled: !(this.selection && this.selection.length)
          }
        ]
      },
      filters () {
        return [
          {
            type: 'keywordFilter',
            props: {}
          }
          // {
          //   type: 'selectFilter',
          //   props: {
          //     filterName: 'status',
          //     clearable: true,
          //     opts: this.statusOptions || [],
          //     defaults: this.selectedStatuses || [],
          //     multi: true,
          //     placeholder: 'Status'
          //   }
          // },
          // {
          //   type: 'autocompleteFilter',
          //   props: {
          //     filterName: 'batch',
          //     remote: true,
          //     clearable: true,
          //     action: 'fetchBatchesWithQuery',
          //     clearAction: 'clearBatchState',
          //     getter: 'getBatchesBySearchCriteria',
          //     triggerOnFocus: false,
          //     placeholder: 'Batch',
          //     queryParamType: 'search',
          //     suggestionLabelAttr: 'name'
          //   }
          // },
          // {
          //   type: 'autocompleteFilter',
          //   props: {
          //     filterName: 'vendor',
          //     remote: true,
          //     clearable: true,
          //     action: 'fetchVendorsWithQuery',
          //     clearAction: 'clearVendorState',
          //     getter: 'getVendorsBySearchCriteria',
          //     triggerOnFocus: false,
          //     placeholder: 'Vendor',
          //     queryParamType: 'search',
          //     suggestionLabelAttr: 'name'
          //   }
          // },
          // {
          //   type: 'selectFilter',
          //   props: {
          //     filterName: 'batch__bank__currency',
          //     clearable: true,
          //     opts: this.$store.getters.getAllCurrencies.map(c => ({ label: c.code, value: c.id })),
          //     multi: true,
          //     placeholder: 'Currency',
          //     styles: '0 4px'
          //   }
          // }
        ]
      }
    },
    mounted () {
      const tableHeight = () => {
        const parentHeight = document.getElementById('pos').offsetHeight
        const headerHeight = document.getElementById('pos-header').offsetHeight
        return parentHeight - headerHeight
      }
      this.tableHeight = tableHeight()
    },
    beforeDestroy () {
      this.$store.dispatch('updateTransactionSelection', [])
      this.$store.dispatch('updateFilteredTransactionSelection', [])
    },
    async beforeRouteEnter (to, from, next) {
      // Settled before the grid is built, so it only finds filters to put back on a return trip
      retainFiltersOnEntry(to.name, from.name)
      try {
        await Promise.all([
          store.dispatch('resetPoMeta'),
          store.dispatch('clearPoState'),
          store.dispatch('fetchUiSetting', { name: 'LINE_FIELD_ORDER' })
        ])
      } catch (e) {
        console.log(e)
      } finally {
        next(vm => {
          vm.filterRetained()
        })
      }
    },
    async beforeRouteLeave (to, from, next) {
      try {
        await store.dispatch('clearPoState', true)
      } catch (e) {
        console.log(e)
      } finally {
        next()
      }
    }
  }
</script>

<style scoped>
  #pos-header {
    border-bottom: 1px solid lightgray;
  }
  .h-padded {
    padding: 0 12px;
  }
  .left-aligned-col {
    text-align: left;
  }
  .right-aligned-col {
    text-align: right;
  }
  .el-table .modified-row {
    background: #c9e5f5;
  }
  .nodata-heading {
    padding: 60px 0;
    color: #a7a7a7;
    font-size: 24px;
  }
  a, a:visited {
    text-decoration: none;
    color: rgb(0, 0, 238) !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/RouteComponents/Pos/Pos.vue